export default __webpack_public_path__ + "static/media/add_plus_icon.d84168c2.svg";